import { IOrgData, OrgRecord, orgFromJSON } from "common/records/Org";
import { Nullable } from "common/types";
import { List, Map, Record, fromJS } from "immutable";

export const accessFromJSON = (json: Partial<IAccessData>): AccessRecord => {
  const record: IAccessRecord = { ...(json as any) };

  if (json.org) {
    record.org = orgFromJSON(json.org);
  }

  if (json.acl) {
    record.acl = fromJS(json.acl) as any;
  }

  return new AccessRecord(record);
};

export interface IAccessData {
  id: number;
  template: string;
  user_id: number;
  org_id: number;
  org: IOrgData;
  uid: string;
  acl?: { [key: string]: string[] };
  billable: string;
  sort_order: number;
  config?: {
    commission_calculator?: {
      overhead: number;
      commission_rate: number;
    };
  };
}

export interface IAccessRecord {
  id: number;
  template: string;
  user_id: number;
  org_id: number;
  org: Nullable<OrgRecord>;
  uid: string;
  acl: Map<string, List<string>>;
  billable: string;
  sort_order: Nullable<number>;
  config?: Map<"commission_calculator", Map<"overhead" | "commission_rate", number>>;
}

const defaultAccessProps: IAccessRecord = {
  id: 0,
  template: "",
  user_id: 0,
  org_id: 0,
  org: null,
  uid: "",
  acl: Map<string, List<string>>(),
  billable: "",
  sort_order: null,
  config: Map(),
};

export class AccessRecord extends Record(defaultAccessProps) implements IAccessRecord {}
